"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { Text } from "@nxt-costco-com/forge-components";
import { memberOnlyContainerStyles } from "../MemberOnlyItemBadge/styles.js";
import GenericImageHandler from "../../../../../Util/GenericImageHandler.js";
import { useProductTileData } from "../../../../../../hooks/useProductTileData/index.js";
import { costcoTravelTextStyles } from "./styles.js";
const COMPONENT_NAME = "CostcoTravelBadge";
const CostcoTravelBadge = ({ uniqueId }) => {
  const { translationsConfig } = useProductTileData();
  const { translations } = translationsConfig || {};
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": `${COMPONENT_NAME}_${uniqueId}`,
      sx: memberOnlyContainerStyles,
      children: [
        /* @__PURE__ */ jsx(
          GenericImageHandler,
          {
            src: (translations == null ? void 0 : translations.costcotravelicon) || "",
            alt: (translations == null ? void 0 : translations.costcotravelbadge) || "",
            loading: "lazy"
          }
        ),
        /* @__PURE__ */ jsx(
          Text,
          {
            sx: costcoTravelTextStyles,
            uniqueId: `${COMPONENT_NAME}_${uniqueId}`,
            variant: "t4",
            children: (translations == null ? void 0 : translations.costcotravelbadge) || ""
          }
        )
      ]
    }
  );
};
export {
  CostcoTravelBadge
};
